import { render } from "./WifiIcon.vue?vue&type=template&id=c3c15188"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/WifiIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3c15188"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3c15188', __exports__)) {
    api.reload('c3c15188', __exports__)
  }
  
  module.hot.accept("./WifiIcon.vue?vue&type=template&id=c3c15188", () => {
    api.rerender('c3c15188', render)
  })

}


export default __exports__